import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap } from 'rxjs/operators';
import { WebDeploymentsApiService } from '../services/web-deployments-api.service';
import * as ConfigurationActions from '../actions/configuration.actions';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudConfigurationEffects {
  readonly loadConfiguration$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ConfigurationActions.loadConfigurations),
      filter((action) => !!action.deploymentId),
      switchMap((action) => this._api.configurations$(action.deploymentId)),
      map((configuration) => ConfigurationActions.configurationChanged({ configuration }))
    )
  );

  constructor(private readonly _actions$: Actions, private readonly _api: WebDeploymentsApiService) {}
}
